import mitt from 'mitt'

type Events = {
    'load:start': any;
    'load:done': any;
    'dialog:show': ConfirmOptions;
    'toast': ToastEvent;
}

export type ConfirmCallback = (result: boolean, input?: string) => any
interface ConfirmOptions {
    title: string;
    text: string;
    callback: ConfirmCallback;
    input?: boolean|undefined;
}

export type ToastType = 'info'|'error'|'warn'|string;

export interface ToastEvent {
    text: string;
    type: ToastType;
}

const events = mitt<Events>()
export default events;
